export default {
	physicalShops: [{
			shopId: '5e9412e0b2bfbc089daerr12',
			shopName: '北环'
		},
		{
			shopId: '5e9412e0b2bfbc089daerr13',
			shopName: '陇海'
		},
		{
			shopId: '5e9412e0b2bfbc089daerr16',
			shopName: '二七'
		},
		{
			shopId: '5e9412e0b2bfbc089daerr18',
			shopName: '云尚'
		},
	],
	get_physicalShops_type(state) {
		let result = '';
		console.log('门店id state',state)
		for (let i = 0; i < this.physicalShops.length; i++) {
			let item = this.physicalShops[i];
			if (state == item.shopId) {
				result = item.shopName
			}
		}
		return result;
	},
	// 合同模板类型
	fileTemplate_type: [{
			id: 2,
			name: '洗美'
		},
		{
			id: 6,
			name: '寄养'
		},
		{
			id: 5,
			name: '医疗服务'
		},
		{
			id: 8,
			name: '活体'
		},
		{
			id: 3,
			name: '病例'
		},
	],
	get_fileTemplate_type(state) {
		let result = '--';
		for (let i = 0; i < this.fileTemplate_type.length; i++) {
			let item = this.fileTemplate_type[i];
			if (state === item.id) {
				result = item.name
			}
		}
		return result;
	},
	// 印章类型
	signature_type: [{
			id: 1,
			name: '公章'
		},
		{
			id: 2,
			name: '合同章'
		},
		{
			id: 3,
			name: '法人章'
		},
		{
			id: 4,
			name: '财务章'
		},
		{
			id: 5,
			name: '发票章'
		},
		{
			id: 6,
			name: '其他用章'
		},
	],
	get_signature_type(state) {
		let result = '--';
		for (let i = 0; i < this.signature_type.length; i++) {
			let item = this.signature_type[i];
			if (state === item.id) {
				result = item.name
			}
		}
		return result;
	},

}
